import type { Feature } from 'geojson'
import { ToGeoJSON } from '../../types/apiModels'

export const getExclusionAreaTypeColor = (exclusionAreaTypeId: string | undefined): string => {
  const colorMap: Record<string, string> = {
    '0': '#87CEEB', // Light blue - Cuerpo de agua (Water body)
    '1': '#D8BE93', // Beige - Camino (Road)
    '2': '#DDB892', // Light beige - Instalaciones (Building)
    '3': '#228B22', // Forest green - Reserva natural (Natural reserve)
    '4': '#32CD32', // Lime green - Monte nativo (Native forest)
    '5': '#2F4F4F', // Dark gray - Zona improductiva (Unproductive area)
    '6': '#4682B4', // Steel blue - Humedal (Wetland)
    '8': '#006400', // Dark green - Bosque implantado (Implanted forest)
    '9': '#5F9EA0', // Cadet blue - Curso de agua (Watercourse)
    '10': '#F5DEB3', // Wheat beige - Deforestación (Deforestation)
    '99': '#9E9E9E', // Gray - Otro (Other)
  }

  return colorMap[exclusionAreaTypeId ?? ''] || '#9E9E9E'
}

/**
 * Get the unique identifier for an exclusion area feature
 * @param feature The exclusion area feature
 * @returns The feature's id or tmpId, or empty string if neither exists
 */
export const getFeatureId = (feature: Feature): string => {
  return feature?.properties?.id || feature?.properties?.tmpId || ''
}

/**
 * Check if two features are the same based on their IDs
 * @param feature1 First feature to compare
 * @param feature2 Second feature to compare
 * @returns True if features have the same ID
 */
export const isSameFeature = (feature1: Feature, feature2: Feature): boolean => {
  return getFeatureId(feature1) === getFeatureId(feature2)
}

/**
 * Find a feature by its ID in an array
 * @param features Array of features to search
 * @param id ID to search for
 * @returns The matching feature, or undefined if not found
 */
export const findFeatureById = (features: Feature[], id: string): Feature | undefined => {
  return features.find(f => getFeatureId(f) === id)
}

export const formattedHectaresArea = (feature: Partial<ToGeoJSON>) => {
  const area = feature.properties?.area
  if (!area) return '0.00 ha'

  if (typeof area === 'string' && (area.includes('ha') || area.includes('m²'))) {
    return area
  }

  if (typeof area === 'number') {
    return `${area.toFixed(2)} ha`
  }

  return 'ÁREA INVÁLIDA'
}
